import styles from './CaseStudyIntroduction.module.scss';

export const CaseStudyIntroduction = () => {
  return (
    <div className={styles.sectionSloganLayout}>
      <h3 className={styles.sectionHeading}>
        <span className={styles.sectionHeadingMain}>Turning Challenges</span>
        <span className={styles.sectionHeadingSubheading}>Into success stories</span>
      </h3>
      <p className={styles.sectionSloganDescription}>
        We believe innovation is the foundation for tackling your challenges and transforming it into outstanding
        projects.
      </p>
    </div>
  );
};
